export const checkCSSPercentValue = (value, cssUnit) => {
  if (!value) return 0

  let stringValue = `${value}`
  return stringValue.includes('%') ? value : value + cssUnit
}
